import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControlLabel, Checkbox, MenuItem, Select, InputLabel, FormControl, Alert } from '@mui/material';
import { httpsCallable } from 'firebase/functions';

const FunnelCreator = ({ open, onClose, functionsInstance }) => {
  const [type, setType] = useState('reply');
  const [trigger, setTrigger] = useState('');
  const [tweetContent, setTweetContent] = useState('');
  const [initialDm, setInitialDm] = useState('');
  const [consentDm, setConsentDm] = useState('');
  const [autoPost, setAutoPost] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const reset = () => {
    setType('reply');
    setTrigger('');
    setTweetContent('');
    setInitialDm('');
    setConsentDm('');
    setAutoPost(false);
    setError(null);
    setSuccess(null);
  };

  const handleClose = () => {
    reset();
    onClose && onClose();
  };

  const handleCreate = async () => {
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      if (!initialDm) throw new Error('Initial DM is required');
      if (!trigger) throw new Error('Trigger keyword or tweet id required');
      const fn = httpsCallable(functionsInstance, 'createFunnel');
      const resp = await fn({ type, trigger, tweet_content: tweetContent, initial_dm: initialDm, consent_dm: consentDm, auto_post: autoPost });
      if (resp && resp.data && resp.data.success) {
        setSuccess('Funnel created');
      } else {
        setSuccess('Funnel created');
      }
    } catch (e) {
      setError(e && e.message ? e.message : String(e));
    }
    setLoading(false);
  };

  return (
    <Dialog open={!!open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Create Opt-In Funnel</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 1 }}>{success}</Alert>}

        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="funnel-type-label">Trigger Type</InputLabel>
          <Select labelId="funnel-type-label" value={type} label="Trigger Type" onChange={(e) => setType(e.target.value)}>
            <MenuItem value="reply">Reply with keyword</MenuItem>
            <MenuItem value="like">Like a tweet</MenuItem>
          </Select>
        </FormControl>

        <TextField fullWidth sx={{ mt: 2 }} label={type === 'reply' ? 'Trigger keyword (e.g., GUIDE)' : 'Tweet ID to watch for likes'} value={trigger} onChange={(e) => setTrigger(e.target.value)} />

        <TextField fullWidth sx={{ mt: 2 }} label="Tweet content (optional, for auto-post)" value={tweetContent} onChange={(e) => setTweetContent(e.target.value)} multiline rows={3} />

        <TextField fullWidth sx={{ mt: 2 }} label="Initial DM to send" value={initialDm} onChange={(e) => setInitialDm(e.target.value)} multiline rows={3} />

        <TextField fullWidth sx={{ mt: 2 }} label="Consent message (optional)" value={consentDm} onChange={(e) => setConsentDm(e.target.value)} multiline rows={2} />

        <FormControlLabel control={<Checkbox checked={autoPost} onChange={(e) => setAutoPost(e.target.checked)} />} label="Auto-post tweet" />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleCreate} variant="contained" disabled={loading}>{loading ? 'Creating...' : 'Create Funnel'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FunnelCreator;
